// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Popover__root--eg63 {
    border-radius: 12px;
    border: 4px solid var(--obscure-color);
    padding: 16px;
    background-color: var(--main-light-color);
    color: var(--secondary-color);
    max-width: 368px;
}

    @media screen and (max-width: 518px) {.Popover__root--eg63 {
        max-width: 100%;
        border-radius: 12px 12px 0 0
}
    }

.Popover__container--NVMJ {
    z-index: 9999;
}

@media screen and (max-width: 518px) {

.Popover__container--NVMJ {
        transform: none !important;
        bottom: 0 !important;
        left: 0 !important;
        top: unset !important;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: flex-end;
        background: #00000099
}
    }

.Popover__head--Q20F {
    display: grid;
    grid-template-columns: 32px auto 40px;
    align-items: center;
    grid-gap: 8px;
    margin-bottom: 16px;
}

.Popover__head--Q20F > img {
        width: 32px;
        height: 32px;
    }

.Popover__head--Q20F > span {
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        color: var(--darkest-color);
    }

.Popover__head--Q20F > svg {
        border-radius: 6px;
        border: 1px solid var(--obscure-color);
        padding: 11px;
        width: 40px;
        height: 40px;
        color: var(--secondary-color);
        cursor: pointer;
        background-color: var(--tertiary-color);
    }

.Popover__description--iOPo {
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
}

.Popover__target--K6HX {
    cursor: pointer;
}

.Popover__target--K6HX > * {
        text-decoration: underline;
        text-decoration-style: dashed;
    }
`, "",{"version":3,"sources":["webpack://./src/ui/components/Popover/Popover.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;IACb,yCAAyC;IACzC,6BAA6B;IAC7B,gBAAgB;AAMpB;;IAJI,sCARJ;QASQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,aAAa;AAajB;;AAXI;;AAHJ;QAIQ,0BAA0B;QAC1B,oBAAoB;QACpB,kBAAkB;QAClB,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,qBAAqB;QACrB;AAER;IADI;;AAGJ;IACI,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AAwBvB;;AAtBI;QACI,WAAW;QACX,YAAY;IAChB;;AAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,2BAA2B;IAC/B;;AAEA;QACI,kBAAkB;QAClB,sCAAsC;QACtC,aAAa;QACb,WAAW;QACX,YAAY;QACZ,6BAA6B;QAC7B,eAAe;QACf,uCAAuC;IAC3C;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AAMnB;;AAJI;QACI,0BAA0B;QAC1B,6BAA6B;IACjC","sourcesContent":[".root {\n    border-radius: 12px;\n    border: 4px solid var(--obscure-color);\n    padding: 16px;\n    background-color: var(--main-light-color);\n    color: var(--secondary-color);\n    max-width: 368px;\n\n    @media (--tiny-only) {\n        max-width: 100%;\n        border-radius: 12px 12px 0 0;\n    }\n}\n\n.container {\n    z-index: 9999;\n\n    @media (--tiny-only) {\n        transform: none !important;\n        bottom: 0 !important;\n        left: 0 !important;\n        top: unset !important;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: flex-end;\n        background: #00000099;\n    }\n}\n\n.head {\n    display: grid;\n    grid-template-columns: 32px auto 40px;\n    align-items: center;\n    grid-gap: 8px;\n    margin-bottom: 16px;\n\n    > img {\n        width: 32px;\n        height: 32px;\n    }\n\n    > span {\n        font-weight: 600;\n        font-size: 18px;\n        line-height: 24px;\n        color: var(--darkest-color);\n    }\n\n    > svg {\n        border-radius: 6px;\n        border: 1px solid var(--obscure-color);\n        padding: 11px;\n        width: 40px;\n        height: 40px;\n        color: var(--secondary-color);\n        cursor: pointer;\n        background-color: var(--tertiary-color);\n    }\n}\n\n.description {\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 20px;\n}\n\n.target {\n    cursor: pointer;\n\n    > * {\n        text-decoration: underline;\n        text-decoration-style: dashed;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Popover__root--eg63`,
	"container": `Popover__container--NVMJ`,
	"head": `Popover__head--Q20F`,
	"description": `Popover__description--iOPo`,
	"target": `Popover__target--K6HX`
};
export default ___CSS_LOADER_EXPORT___;
